import React, { Component, PropTypes } from 'react';

import { Breadcrumb, Button, message, Modal, Input, Select, Row, Col, } from 'antd';

import QuestionnaireListGrid from './QuestionnaireListGrid';
import AnswereeSelectDialog from './AnswereeSelectDialog';
import QuestionnaireEditDialog from './QuestionnaireEditDialog';
import QuestionEditDialog from './QuestionEditDialog';
import './Questionnaire.css';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import QuestionnaireOpMode from '../../../../utils/QuestionnaireOpMode';

const confirm = Modal.confirm;

class QuestionnaireList extends Component {

  componentDidMount() {
    this.props.loadQuestionnaires({ questionnaireVersion: undefined, nameOnQuestionnaire: undefined, status: 'Activated' });;
    // 默认勾选已选择的答题人
    this.props.loadAnswers();
  }

  componentDidUpdate() {
    const {
      batchDeleteQuestionnairesActionStatus,
      batchDeleteQuestionsActionStatus,
      questionnaireQueryFields,
    } = this.props;

    // 批量删除 Questionnaire 成功
    if (batchDeleteQuestionnairesActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Questionnaires are deleted successfully!');
      const {
        questionnaireVersion,
        nameOnQuestionnaire,
        status,
      } = questionnaireQueryFields || {};
      this.props.loadQuestionnaires({ questionnaireVersion, nameOnQuestionnaire, status });
      this.props.initBatchDeleteQuestionnaireActionStatus();
    }

    // 批量删除 Questionnaire 失败
    if (batchDeleteQuestionnairesActionStatus === ACTION_STATUS.ERROR) {
      message.error('Questionnaires are deleted failed!');
      this.props.initBatchDeleteQuestionnaireActionStatus();
    }

    // 批量删除 Question 成功
    if (batchDeleteQuestionsActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Questions are deleted successfully!');
      const {
        questionnaireVersion,
        nameOnQuestionnaire,
        status,
      } = questionnaireQueryFields || {};
      this.props.loadQuestionnaires({ questionnaireVersion, nameOnQuestionnaire, status });
      this.props.initBatchDeleteQuestionActionStatus();
    }

    // 批量删除 Question 失败
    if (batchDeleteQuestionsActionStatus === ACTION_STATUS.ERROR) {
      message.error('Questions are deleted failed!');
      this.props.initBatchDeleteQuestionActionStatus();
    }
  }

  addQuestionnaireButtonOnClicked = () => {
    this.props.openQuestionnaireEditModalDialog(QuestionnaireOpMode.NEW, null);
  }

  addQuestionButtonOnClicked = () => {
    this.props.openQuestionEditModalDialog(true, null);
  }

  editQuestionnaireButtonOnClicked = () => {
    const {
      selectedQuestionnaires,
    } = this.props;

    if (selectedQuestionnaires.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    this.props.openQuestionnaireEditModalDialog(QuestionnaireOpMode.MODIFY, selectedQuestionnaires[0]);
  }

  copyQuestionnaireButtonOnClicked = () => {
    const {
      selectedQuestionnaires,
    } = this.props;

    if (selectedQuestionnaires.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    this.props.openQuestionnaireEditModalDialog(QuestionnaireOpMode.COPY, selectedQuestionnaires[0]);
  }

  editQuestionButtonOnClicked = () => {
    const {
      selectedQuestions
    } = this.props;

    if (selectedQuestions.length !== 1) {
      message.warning("Please select one question!");
      return;
    }

    this.props.openQuestionEditModalDialog(false, selectedQuestions[0]);
  }

  delQuestionnaireButtonOnClicked = () => {
    const {
      selectedQuestionnaires,
    } = this.props;

    if (selectedQuestionnaires.length === 0) {
      message.warning("Please select one questionnaire at least!");
      return;
    }

    let that = this;
    confirm({
      title: 'Are you sure you want to delete the questionnaires?',
      content: '',
      onOk() {
        const questionnaireIdList = selectedQuestionnaires.map(questionnaire => questionnaire.guid);

        that.props.batchDeleteQuestionnaire(questionnaireIdList);
      },
      onCancel() { },
    });
  }

  delQuestionButtonOnClicked = () => {
    const {
      selectedQuestions
    } = this.props;

    if (selectedQuestions.length === 0) {
      message.warning("Please select one question at least!");
      return;
    }

    let that = this;
    confirm({
      title: 'Are you sure you want to delete the questions?',
      content: '',
      onOk() {
        const questionIdList = selectedQuestions.map(question => question.guid);

        that.props.batchDeleteQuestion(questionIdList);
      },
      onCancel() { },
    });
  }

  previewButtonOnClicked = () => {
    const {
      selectedQuestionnaires,
    } = this.props;

    if (selectedQuestionnaires.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    const questionnaire = selectedQuestionnaires[0];

    this.props.history.push(`/questionnaire-preview/${questionnaire.guid}`);
  }

  selAnswereeButtonOnClicked = () => {
    const {
      selectedQuestionnaires
    } = this.props;

    if (selectedQuestionnaires.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    this.props.loadUserAccounts();  // 每次打开页面需要先刷新userAccount
    this.props.openAnswereeSelectModalDialog();
  }

  refreshButtonOnClicked = () => {
    const {
      questionnaireVersion,
      nameOnQuestionnaire,
      status,
    } = this.props.questionnaireQueryFields;

    this.props.loadQuestionnaires({ questionnaireVersion, nameOnQuestionnaire, status });
    // 默认勾选已选择的答题人
    // this.props.loadAnswers();
  }
  onInputChange = ({ name, value }) => {
    this.props.onQueryInputChange({ name, value });
  };
  render() {
    const {
      statusOptions,
      loadQuestionnairesActionStatus,
    } = this.props;

    const refreshBtnIsLoading = loadQuestionnairesActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="questionnaireListWrapper">

        <div className='breadcrumbWrapper'>
          <Breadcrumb>
            <Breadcrumb.Item>Questionnaire</Breadcrumb.Item>
            <Breadcrumb.Item>Question List</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className='operationBar'>
          <div className='breadcrumbWrapper'>
            <Breadcrumb>
              <Breadcrumb.Item>  Search by:</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Input
            placeholder="Questionnaire Version"
            size="small"
            style={{ width: 360, marginLeft: 10 }}
            onPressEnter={this.refreshButtonOnClicked}
            onChange={(event) => {
              this.onInputChange({ name: 'questionnaireVersion', value: event.target.value })
            }}
          />
          <Input
            placeholder="Name on Questionnairener"
            size="small"
            style={{ width: 220, marginLeft: 10 }}
            onPressEnter={this.refreshButtonOnClicked}
            onChange={(event) => {
              this.onInputChange({ name: 'nameOnQuestionnaire', value: event.target.value })
            }}
          />
          <Select
            allowClear
            size='small'
            style={{ width: 150, marginLeft: 10 }}
            defaultValue="Activated"
            value={this.props.questionnaireQueryFields ? this.props.questionnaireQueryFields.status : undefined}
            onChange={(val) => {
              this.onInputChange({ name: 'status', value: val })
            }}
            placeholder="Status">
            {statusOptions}
          </Select>
          <Button
            onClick={this.refreshButtonOnClicked}
            loading={refreshBtnIsLoading}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'
            icon="search"
          />
        </div>
        <div className='breadcrumbWrapper'>
          <Button
            onClick={this.addQuestionnaireButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            className='positive-button'>
            Add Questionnaire
          </Button>

          <Button
            onClick={this.addQuestionButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            className='positive-button'>
            Add Question
          </Button>

          <Button
            onClick={this.editQuestionnaireButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Edit Questionnaire
          </Button>

          <Button
            onClick={this.copyQuestionnaireButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Copy Questionnaire
          </Button>

          <Button
            onClick={this.editQuestionButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Edit Question
          </Button>

          <Button
            onClick={this.delQuestionnaireButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            className='negative-button'>
            Del Questionnaire
          </Button>

          <Button
            onClick={this.delQuestionButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            className='negative-button'>
            Del Question
          </Button>

          <Button
            onClick={this.refreshButtonOnClicked}
            loading={refreshBtnIsLoading}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Refresh
          </Button>

          <Button
            onClick={this.previewButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Preview
          </Button>

          <Button
            onClick={this.selAnswereeButtonOnClicked}
            size='small'
            style={{ marginLeft: 10 }}
            type='primary'>
            Select Answeree
          </Button>
        </div>

        <div className='questionnaireListGrid'>
          <QuestionnaireListGrid {...this.props} />
        </div>

        <AnswereeSelectDialog {...this.props} />
        <QuestionnaireEditDialog {...this.props} />
        <QuestionEditDialog {...this.props} />
      </div>
    );
  }
}

export default QuestionnaireList;